import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core'
import { MediaInterface } from '../../../interfaces'

@Component({
  selector: 'dmmp-image-link',
  templateUrl: './image-link.component.html'
})
export class ImageLinkComponent implements OnInit {

  @Input() item
  @Output() page = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  @Input() medias: MediaInterface[] = [
    { style: 'large', media: '(min-width:260px)' }
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
